import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

import useGetRowData from '../hooks/useGetRowData';
import CreateEditHolidayForm from './CreateEditHolidayForm';

export default function CreateEditHoliday({
  handleClose,
  rowId
}: FormComponentProps) {
  const { isFetching, data } = useGetRowData(Number(rowId));

  return isFetching ? (
    <DrawerFormSkeleton count={3} height={40} />
  ) : (
    <CreateEditHolidayForm handleClose={handleClose} rowData={data} />
  );
}
